// @flow
import {
    BATCH_CLOSE_MODAL,
    BATCH_FAIL_ITEM,
    BATCH_FINISH,
    BATCH_PROGRESS,
    BATCH_START,
    BATCH_SUCCESS_ITEM
} from "./constants";

const initialState = {
    isRunning: false,
    isModalOpen: false,
    progress: 0,
    total: 0,
    successIds: [],
    failed: [],
    status: "idle"
};

export default function batchReducer(state = initialState, action) {
    switch (action.type) {
        case BATCH_START:
            return {
                ...state,
                isRunning: true,
                isModalOpen: true,
                progress: 0,
                successIds: [],
                failed: [],
                status: "running"
            };

        case BATCH_PROGRESS:
            return {
                ...state,
                progress: action.payload.current,
                total: action.payload.total,
                label: action.payload.label,
            };

        case BATCH_SUCCESS_ITEM:
            return {
                ...state,
                successIds: [...state.successIds, action.payload.id]
            };

        case BATCH_FAIL_ITEM:
            return {
                ...state,
                failed: [...state.failed, action.payload]
            };

        case BATCH_FINISH:
            return {
                ...state,
                isRunning: false,
                status: action.payload.status
            };
        case BATCH_CLOSE_MODAL:
            return {
                ...state,
                isModalOpen: false
            };

        default:
            return state;
    }
}